import { Box, SkeletonGroup } from '@wix/design-system'
import React, { FC } from 'react'

import s from './SkeletonLoader.scss'

export const SkeletonLoader: FC = () => {
  return (
    <SkeletonGroup className={s.group}>
      <Box height="100%" backgroundColor="rgba(134, 138, 165, 0.2)" />
    </SkeletonGroup>
  )
}
